import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.closeModal()
    this.scheduleRemoval()
  }
  
  closeModal() {
    const modal = document.getElementById('modal')
    if (modal) {
      modal.innerHTML = ''
    }
    
    const turboModalElement = document.querySelector('[data-controller*="turbo-modal"]')
    if (turboModalElement?.turboModalController) {
      try {
        turboModalElement.turboModalController.close()
      } catch (error) {
        // Fallback to manual close if controller method fails
      }
    }
  }
  
  scheduleRemoval() {
    setTimeout(() => {
      this.element?.remove()
    }, 100)
  }
}